import React from 'react';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';

import Row from './Common/Row';

const Warning = ({
  warnings,
  isFirstLineBold,
}: {
  warnings: string[];
  isFirstLineBold?: boolean;
}) => {
  return (
    <Row
      style={{
        backgroundColor: 'var(--color-avatar-3-bg)',
        padding: 8,
      }}
    >
      <Icon icon="warning" color={'var(--color-status-warning)'} />
      <div>
        {warnings.map((warning, index) => (
          <div style={{ marginLeft: 8 }} key={warning}>
            <Typography.Body
              type="Body 12"
              color={isFirstLineBold && index === 0 ? 'black' : undefined}
            >
              {warning}
            </Typography.Body>
          </div>
        ))}
      </div>
    </Row>
  );
};

export default Warning;
